import { render, staticRenderFns } from "./LiveChatNotification.vue?vue&type=template&id=0c577957"
import script from "./LiveChatNotification.vue?vue&type=script&lang=js"
export * from "./LiveChatNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports